// Названия из баланса (войска, предметы, товары, исследования, задания…) хранятся по-русски и по-английски.
// Китайский — словарь «английское название → китайское» (locales/zh/names.json); нет в словаре — английское.
// Экземпляр i18next напрямую (без инициализации @/i18n — так модуль проще подменять в тестах)
import i18n from 'i18next';
import zhNames from './locales/zh/names.json';

const ZH = zhNames as Record<string, string>;

/** Язык интерфейса; до инициализации i18next (и в тестах) — русский, как по умолчанию в игре. */
const current = () => i18n.language || 'ru';

/** Название на языке игрока по паре «русское, английское». */
export function lname(ru: string | null | undefined, en: string | null | undefined): string {
  const lang = current();
  if (lang === 'ru') return ru ?? en ?? '';
  if (lang === 'zh') return (en && ZH[en]) || en || ru || '';
  return en ?? ru ?? '';
}

/** Язык названий из баланса для функций shared (unitName, depositName): там только ru/en. */
export function balanceLang(): 'ru' | 'en' {
  return current() === 'ru' ? 'ru' : 'en';
}

/** Перевод английского названия на язык игрока (для shared-функций, возвращающих en). */
export function fromEn(en: string): string {
  return current() === 'zh' ? (ZH[en] ?? en) : en;
}

/** Текст, записанный прямо в компоненте на трёх языках. */
export function tri(ru: string, en: string, zh: string): string {
  const lang = current();
  return lang === 'ru' ? ru : lang === 'zh' ? zh : en;
}
